export default __webpack_public_path__ + "79bd1eca29fbf127d54e442f73e677c6.png";